import {
  Button,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  CardActionArea,
  CardHeader,
  Collapse,
  Grid,
  Icon,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { EmptyState } from "components/EmptyState";
import i18n from "i18n/i18n";
import { ReactComponent as AddSvg } from "assets/Svgs/AddSvg.svg";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { Box, SelectChangeEvent } from "@mui/material";
import { useEffect, useState } from "react";
import { ReactComponent as EditSvg } from "assets/Svgs/Edit.svg";
import { ReactComponent as DeleteSvg } from "assets/Svgs/delete.svg";

import Paper from "@mui/material/Paper";
import { faqData } from "utils/dummy";
import { DeleteForeverOutlined } from "@mui/icons-material";
import NotificationAttachments from "components/NotificationAttachments";
import { useBoundStore } from "store/store";
import { Link, useLocation } from "react-router-dom";
import EditFaq from "components/EditFaq";
import {
  allow_docs_mimetypes,
  allow_videos_mimetypes,
  allow_images_mimetypes,
} from "utils/helper";
import { v4 as uuidv4 } from "uuid";
import { ReactComponent as Magnifier } from "assets/Svgs/magnifier.svg";
import { Delete } from "@mui/icons-material";

import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";

import AttachmentIcon from "@mui/icons-material/Attachment";
import mimee from "mime";

import Lightbox from "yet-another-react-lightbox";
import Download from "yet-another-react-lightbox/plugins/download";
import "yet-another-react-lightbox/styles.css";

function Faq(props: any) {
  const lang: any = useBoundStore((state) => state.lang);

  const { machineData } = props;
  const loadEquipmentDetails = useBoundStore(
    (state) => state.loadEquipmentDetails
  );
  const isAuthUser = useBoundStore((state) => state.isAuthUser);
  const deleteFaq = useBoundStore((state) => state.deleteFaq);

  const [showMoreImages, setShowMoreImages] = useState(false);
  const [showMoreVideos, setShowMoreVideos] = useState(false);
  const [showMoreDocs, setShowMoreDocs] = useState(false);

  const [preImages, setPreImages] = useState([]);
  const [preVideos, setPreVideos] = useState([]);
  const [preDocs, setPreDocs] = useState([]);

  useEffect(() => {
    var images: any = [];
    var videos: any = [];
    var docs: any = [];
    if (
      machineData?.equipment?.hasquestionanswer &&
      machineData?.equipment?.hasquestionanswer.length > 0
    ) {
      machineData?.equipment?.hasquestionanswer.map((i: any, k: any) => {
        if (i?.questionanswer?.hasattachment) {
          i.questionanswer.hasattachment.map((i: any, k: any) => {
            var mime = i?.attachment?.file?.mimetype;
            if (allow_images_mimetypes.includes(mime)) {
              images.push({
                nodeid: i?.attachment?.nodeid,
                url: i?.attachment?.file?.url,
                uuid: uuidv4(),
              });
            } else if (mime?.includes("video")) {
              videos.push({
                qaId: i.nodeid,
                nodeid: i?.attachment?.nodeid,
                url: i?.attachment?.file?.url,
                uuid: uuidv4(),
              });
            } else if (allow_docs_mimetypes.includes(mime?.split("/")[0])) {
              docs.push({
                nodeid: i?.attachment?.nodeid,
                url: i?.attachment?.file?.url,
                title: i?.attachment?.title !== null
                  ? i?.attachment?.title[lang]
                  : i?.attachment?.title,
                mimetype: mime,
                uuid: uuidv4(),
              });
            }
          });
        }
      });
      setPreImages(images);
      setPreVideos(videos);
      setPreDocs(docs);
    }

    return () => {
      // Unmount states
      if (!props.edit) {
        setPreImages([]);
        setPreVideos([]);
        setPreDocs([]);
      }
    };
  }, [props]);

  const getAttachments = (i:any) => {
    var images: any = [];
    var videos: any = [];
    var docs: any = [];
    
        if (i?.questionanswer?.hasattachment) {
          i.questionanswer.hasattachment.map((i: any, k: any) => {
            var mime = i?.attachment?.file?.mimetype;
            if (allow_images_mimetypes.includes(mime)) {
              images.push({
                nodeid: i?.attachment?.nodeid,
                url: i?.attachment?.file?.url,
                uuid: uuidv4(),
              });
            } else if (mime?.includes("video")) {
              videos.push({
                qaId: i.nodeid,
                nodeid: i?.attachment?.nodeid,
                url: i?.attachment?.file?.url,
                uuid: uuidv4(),
              });
            } else if (allow_docs_mimetypes.includes(mime?.split("/")[0])) {
              docs.push({
                nodeid: i?.attachment?.nodeid,
                url: i?.attachment?.file?.url,
                title: i?.attachment?.title !== null
                  ? i?.attachment?.title[lang]
                  : i?.attachment?.title,
                mimetype: mime,
                uuid: uuidv4(),
              });
            }
          });
        }
      
      return {
        images: images,
        videos: videos,
        docs: docs,
      };
    }

  // Function to remove an element from the array
  const deleteLocalImage = (id: any) => {};

  const deleteSingleVideo = (id: any) => {};

  const deleteSingleDocs = (id: any) => {};

  const handleShowMoreImages = () => {
    setShowMoreImages((prev) => !prev);
  };

  const handleShowMoreVideos = () => {
    setShowMoreVideos((prev) => !prev);
  };

  const handleShowMoreDocs = () => {
    setShowMoreDocs((prev) => !prev);
  };

  const handleDelete = async (nodeid: any) => {
    const promises: any[] = [deleteFaq(nodeid, machineData?.equipment?.nodeid)]; // Ensure that promises is an array

    if (isAuthUser === true) {
      try {
        const result = await Promise.all(promises);
       

        setTimeout(() => {
          loadEquipmentDetails(machineData?.equipment?.nodeid, lang);
        }, 2000);
      } catch (error) {
        console.error("Error during promise execution:", error);
      }
    }
  };

  const [editFaq, setEditFaq] = useState(-1);

  const [open, setOpen] = useState(false);
  const [lightBoxUrl, setLightBoxUrl] = useState("");

  const onImgClick = (e: any, url: any) => {
    e.preventDefault();
    setOpen(true);
    setLightBoxUrl(url);
  };

  return (
    <div>
      {open && (
        <Lightbox
          open={open}
          close={() => {
            setOpen(false);
          }}
          slides={[{ src: lightBoxUrl }]}
          plugins={[Download]}
        />
      )}

      
      <div className="faqWrapper">
        <div className="flex fBetween fCenter">
          <div className="generalHeading" style={{ padding: "0px" }}>
            {i18n(lang)?.empty_state_faq_heading}
          </div>

          <div>
            <Link
              to="/create-faq"
              state={{
                from: "faq",
                pageType: "add",
                specifier: "internalfaq",
                equipmentnodeid: machineData?.equipment?.nodeid,
              }}
            >
              <Button
                startIcon={<AddSvg />}
                variant="contained"
                className="lp125"
                sx={{ backgroundColor: "var(--primary-color)" }}
              >
                {i18n(lang)?.add_new_faq}
              </Button>
            </Link>
          </div>
        </div>
        <div className="history_description">{i18n(lang)?.faq_description}</div>

        <div className="faqAccordian">
          {machineData?.equipment?.hasquestionanswer
            ? machineData?.equipment?.hasquestionanswer?.map(
                (data: any, index: any) => {

                  let {images,videos,docs } = getAttachments(data);

                  return (
                    <Accordion key={index}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        sx={{ padding: 0 }}
                        className="accSummary"
                      >
                        <Typography
                          component={"span"}
                          className={" title "}
                          style={{ marginLeft: 0, fontFamily: "Roboto" }}
                        >
                          {data?.questionanswer?.question}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails sx={{ padding: "8px 16px 16px 0px" }}>
                        {editFaq === index ? (
                          <EditFaq
                            question={data?.questionanswer?.question}
                            answer={data?.questionanswer?.answer}
                            questionanswerAttachments={
                              data?.questionanswer?.hasattachment
                            }
                            index={index}
                            pageType="edit"
                            specifier="internalfaq"
                            equipmentnodeid={machineData?.equipment?.nodeid}
                            from="faq"
                            questionanswernodeid={data?.questionanswer?.nodeid}
                            edit={true}
                          />
                        ) : (
                          <>
                            <Typography component={"span"}>
                              <>{data?.questionanswer?.answer}</>
                            </Typography>

                            {/* Images */}
                            <Grid item xs={12}>
                              <Grid container spacing={3}>
                                <Grid item xs={9}>
                                  {images.length ? (
                                    <>
                                      <div
                                        className="generalHeading"
                                        style={{ marginTop: "10px" }}
                                      >
                                        {i18n(lang)?.heading_photos}
                                      </div>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexWrap: "wrap",
                                        }}
                                      >
                                        {images &&
                                          images.length > 0 &&
                                          images
                                            .slice(0, 3)
                                            ?.map((i: any, e:any) => {
                                              return (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    margin:
                                                      "12px 12px 12px 0px",
                                                    position: "relative",
                                                  }}
                                                  key={i.uuid}
                                                >
                                                  <button className="mediaWrapper bxShadow">
                                                  

                                                    <img
                                                      src={i.url}
                                                      alt={
                                                        i18n(lang)?.image_here
                                                      }
                                                      className="string"
                                                    />
                                                    <div
                                                      className="magnifier"
                                                    
                                                    >
                                                      <Magnifier
                                                        onClick={(e) => {
                                                          onImgClick(e, i.url);
                                                        }}
                                                      />
                                                    </div>
                                                  </button>
                                                  {props?.edit ? (
                                                    <IconButton
                                                   
                                                    >
                                                      <Delete />
                                                    </IconButton>
                                                  ) : (
                                                    ""
                                                  )}
                                                </div>
                                              );
                                            })}
                                      </div>
                                    </>
                                  ) : (
                                    ""
                                  )}
<br/>
                                  {images.length > 3 ? (
                                    <div
                                      onClick={handleShowMoreImages}
                                      className="showMore"
                                    >
                                      <div>
                                        {i18n(lang)?.show_n_more.replace(
                                          "%s",
                                          "" + images.slice(3).length
                                        )}
                                      </div>{" "}
                                      <div className="icon">
                                        {" "}
                                        {showMoreImages ? (
                                          <ExpandLessRoundedIcon />
                                        ) : (
                                          <ExpandMoreRoundedIcon />
                                        )}
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}

                                  { images.length > 3 ? (
                                    <>
                                      <Collapse
                                        in={showMoreImages}
                                        timeout="auto"
                                        unmountOnExit
                                      >
                                        <div
                                          className={"uploadedMediaContainer"}
                                          style={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                          }}
                                        >
                                          {images
                                            .slice(3)
                                            ?.map((i: any, e:any) => {
                                              return (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    margin:
                                                      "12px 12px 12px 0px",
                                                    position: "relative",
                                                  }}
                                                  key={i.uuid}
                                                >
                                                  <button className="mediaWrapper bxShadow">
                                                    <img
                                                      src={i.url}
                                                      alt={
                                                        i18n(lang)?.image_here
                                                      }
                                                      className="string dog"
                                                    />
                                                    <div
                                                      className="magnifier"
                                                     
                                                    >
                                                      <Magnifier
                                                        onClick={(e) => {
                                                          onImgClick(e, i.url);
                                                        }}
                                                      />
                                                    </div>
                                                  </button>
                                                </div>
                                              );
                                            })}
                                        </div>
                                      </Collapse>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </Grid>
                              </Grid>
                            </Grid>

                            {/* Videos */}
                            <Grid item xs={12}>
                              <Grid container spacing={3}>
                                <Grid item xs={9}>
                                  {videos.length ? (
                                    <>
                                      <div
                                        className="generalHeading"
                                        style={{ marginTop: "10px" }}
                                      >
                                        {i18n(lang)?.heading_videos}
                                      </div>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexWrap: "wrap",
                                        }}
                                      >
                                        {videos &&
                                          videos.length > 0 &&
                                          videos
                                            .slice(0, 3)
                                            ?.map((i: any, e:any) => {
                                              return (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    margin:
                                                      "12px 12px 12px 0px",
                                                    position: "relative",
                                                  }}
                                                  key={i?.attachment?.uuid}
                                                >
                                                  <button className="mediaWrapper bxShadow">
                                                    

                                                    <video
                                                      controls
                                                      width="100%"
                                                      height="100%"
                                                    >
                                                      <source src={i.url} />
                                                      {
                                                        i18n(lang)
                                                          ?.browser_doesnot_support
                                                      }
                                                    </video>
                                                  </button>
                                                </div>
                                              );
                                            })}
                                      </div>
                                    </>
                                  ) : (
                                    ""
                                  )}

<br/>

                                  {videos.length > 3 ? (
                                    <div
                                      onClick={handleShowMoreVideos}
                                      className="showMore"
                                    >
                                      <div>
                                        {i18n(lang)?.show_n_more.replace(
                                          "%s",
                                          "" + videos.slice(3).length
                                        )}
                                      </div>{" "}
                                      <div className="icon">
                                        {" "}
                                        {showMoreVideos ? (
                                          <ExpandLessRoundedIcon />
                                        ) : (
                                          <ExpandMoreRoundedIcon />
                                        )}
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}

                                  { videos.length > 3 ? (
                                    <>
                                      <Collapse
                                        in={showMoreVideos}
                                        timeout="auto"
                                        unmountOnExit
                                      >
                                        <div
                                          className={"uploadedMediaContainer"}
                                          style={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                          }}
                                        >
                                          {videos
                                            .slice(3)
                                            ?.map((i: any, e:any) => {
                                              return (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    margin:
                                                      "12px 12px 12px 0px",
                                                    position: "relative",
                                                  }}
                                                  key={i.uuid}
                                                >
                                                  <button className="mediaWrapper bxShadow">
                                                    <video
                                                      controls
                                                      width="100%"
                                                      height="100%"
                                                    >
                                                      <source src={i.url} />
                                                      {
                                                        i18n(lang)
                                                          ?.browser_doesnot_support
                                                      }
                                                    </video>
                                                  </button>
                                                </div>
                                              );
                                            })}
                                        </div>
                                      </Collapse>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </Grid>
                              </Grid>
                            </Grid>

                            {/* Docs */}
                            <Grid item xs={12}>
                              <Grid container spacing={3}>
                                <Grid item xs={9}>
                                  {docs.length ? (
                                    <>
                                      <div
                                        className="generalHeading"
                                        style={{ marginTop: "10px" }}
                                      >
                                        {i18n(lang)?.heading_docs}
                                      </div>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexWrap: "wrap",
                                        }}
                                      >
                                        {docs &&
                                          docs.length > 0 &&
                                          docs
                                            .slice(0, 3)
                                            ?.map((i: any, e:any) => {
                                              let mimeType = mimee?.getExtension(
                                                i?.mimetype
                                              );
                                              return (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    margin:
                                                      "12px 12px 12px 0px",
                                                  }}
                                                  key={i?.uuid}
                                                >
                                                  <Card
                                                    className={
                                                      "cardButtonLarge"
                                                    }
                                                    variant="outlined"
                                                    onClick={() => {
                                                      
                                                      window.open(
                                                        i?.url,
                                                        "PDF Viewer"
                                                      );
                                                    }}
                                                  >
                                                    <CardActionArea
                                                      sx={{
                                                        border:
                                                          "1px solid rgba(0, 0, 0, 0.12)",
                                                      }}
                                                    >
                                                      <CardHeader
                                                        avatar={
                                                          <Icon
                                                            color="primary"
                                                            className={
                                                              "cardIcon"
                                                            }
                                                          >
                                                            <AttachmentIcon />
                                                          </Icon>
                                                        }
                                                        style={{
                                                          height: "70px",
                                                        }}
                                                        subheader={
                                                          <div className="attachmentWrapper">
                                                            <div className="content">
                                                              <div className="attachmentHeader">
                                                                {i?.title
                                                                  ? i?.title
                                                                  : i18n(lang)
                                                                      .no_workflow_title}{" "}
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "2px",
                                                                  }}
                                                                  className="mimeType"
                                                                >
                                                                  {mimeType
                                                                    ? mimeType
                                                                    : "no_type"}{" "}
                                                                </span>
                                                              </div>
                                                              <div
                                                                className="attachmentSubHeader"
                                                                style={{
                                                                  width:
                                                                    "max-content",
                                                                }}
                                                              >
                                                                {i?.description
                                                                  ? i?.description
                                                                  : ""}{" "}
                                                              </div>
                                                            </div>
                                                          </div>
                                                        }
                                                      />
                                                    </CardActionArea>
                                                  </Card>
                                                  {props.edit ? (
                                                    <IconButton
                                                      className={"deleteButton"}
                                                      onClick={() =>
                                                        deleteSingleDocs(
                                                          i?.uuid
                                                        )
                                                      }
                                                      style={{
                                                        marginBottom: 8,
                                                      }}
                                                    >
                                                      <Delete />
                                                    </IconButton>
                                                  ) : (
                                                    ""
                                                  )}
                                                </div>
                                              );
                                            })}
                                      </div>
                                    </>
                                  ) : (
                                    ""
                                  )}

<br/>

                                  { docs.length > 3 ? (
                                    <div
                                      onClick={handleShowMoreDocs}
                                      className="showMore"
                                    >
                                      <div>
                                        {i18n(lang)?.show_n_more.replace(
                                          "%s",
                                          "" + docs.slice(3).length
                                        )}
                                      </div>{" "}
                                      <div className="icon">
                                        {" "}
                                        {showMoreDocs ? (
                                          <ExpandLessRoundedIcon />
                                        ) : (
                                          <ExpandMoreRoundedIcon />
                                        )}
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}

                                  {docs.length > 3 ? (
                                    <>
                                      <Collapse
                                        in={showMoreDocs}
                                        timeout="auto"
                                        unmountOnExit
                                      >
                                        <div
                                          className={"uploadedMediaContainer"}
                                          style={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                          }}
                                        >
                                          {docs
                                            .slice(3)
                                            ?.map((i: any, e:any) => {
                                              let mimeType = mimee?.getExtension(
                                                i?.mimetype
                                              );
                                              return (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    margin: "12px",
                                                  }}
                                                  key={i?.uuid}
                                                >
                                                  <Card
                                                    className={
                                                      "cardButtonLarge"
                                                    }
                                                    variant="outlined"
                                                    onClick={() => {
                                                     
                                                      window.open(
                                                        i?.url,
                                                        "PDF Viewer"
                                                      );
                                                    }}
                                                  >
                                                    <CardActionArea
                                                      sx={{
                                                        border:
                                                          "1px solid rgba(0, 0, 0, 0.12)",
                                                      }}
                                                    >
                                                      <CardHeader
                                                        avatar={
                                                          <Icon
                                                            color="primary"
                                                            className={
                                                              "cardIcon"
                                                            }
                                                          >
                                                            <AttachmentIcon />
                                                          </Icon>
                                                        }
                                                        style={{
                                                          height: "70px",
                                                        }}
                                                        subheader={
                                                          <div className="attachmentWrapper">
                                                            <div className="content">
                                                              <div className="attachmentHeader">
                                                                {i.title
                                                                  ? i.title
                                                                  : i18n(lang)
                                                                      .no_workflow_title}{" "}
                                                                <span
                                                                  style={{
                                                                    marginLeft:
                                                                      "2px",
                                                                  }}
                                                                  className="mimeType"
                                                                >
                                                                  {mimeType
                                                                    ? mimeType
                                                                    : "no_type"}{" "}
                                                                </span>
                                                              </div>
                                                              <div
                                                                className="attachmentSubHeader"
                                                                style={{
                                                                  width:
                                                                    "max-content",
                                                                }}
                                                              >
                                                                {i.description
                                                                  ? i.description
                                                                  : ""}{" "}
                                                              </div>
                                                            </div>
                                                          </div>
                                                        }
                                                      />
                                                    </CardActionArea>
                                                  </Card>
                                                  {props.edit ? (
                                                    <IconButton
                                                      className={"deleteButton"}
                                                      onClick={() =>
                                                        deleteSingleDocs(i.uuid)
                                                      }
                                                      style={{
                                                        marginBottom: 8,
                                                      }}
                                                    >
                                                      <Delete />
                                                    </IconButton>
                                                  ) : (
                                                    ""
                                                  )}
                                                </div>
                                              );
                                            })}
                                        </div>
                                      </Collapse>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </Grid>
                              </Grid>
                            </Grid>
                          </>
                        )}

                        <div style={{ display: "flex", marginTop: "15px" }}>
                          <div>
                            <div
                           
                            >
                              <Button
                                size="large"
                                variant="outlined"
                                startIcon={<EditSvg />}
                                style={{
                                  marginBottom: 21,
                                  border: "1px solid #0000001F",
                                  height: "36px",
                                  fontSize: "14px",
                                  fontWeight: "500",
                                }}
                                onClick={() => {
                                  setEditFaq(index);
                                }}
                              >
                                {i18n(lang)?.update_faq}
                              </Button>
                            </div>
                          </div>
                          <div>
                            <Button
                              size="large"
                              variant="outlined"
                              onClick={() => {
                                handleDelete(data?.questionanswer?.nodeid);
                              }}
                              startIcon={<DeleteForeverOutlined />}
                              style={{
                                marginLeft: 21,
                                color: "red",
                                border: "1px solid #0000001F",
                                height: "36px",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                            >
                              {i18n(lang)?.delete}
                            </Button>
                          </div>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  );
                }
              )
            : ""}
        </div>
      </div>
    </div>
  );
}

export default Faq;
